<template>
<v-container style="min-height:100%">

  <v-snackbar timeout="2000"  v-model="snackbar">
     کپی انجام شد
    </v-snackbar>

     <v-dialog
      v-model="dialog"
      
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
        فعال سازی اشتراک 
     <span v-if="plan ==0">شش ماهه</span>
          <span v-if="plan ==1">سه ماهه</span>
               <span v-if="plan ==2">یک ماهه</span>
        </v-card-title>
        <v-card-text>

    <v-row>
            <v-col style="text-align:right" cols="6">مبلغ</v-col>
            <v-col style="text-align:left" cols="6">
              <p class="my-0">
                   <span > {{(user.plan_prices[plan]*1000).toLocaleString("fa-IR")}} تومان</span>
              </p>
              </v-col>

            <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>

    </v-row>
              <v-radio-group v-if="false" v-model="gateway">
      <template v-slot:label>
        <div style="text-align:right"><strong>انتخاب درگاه پرداخت </strong></div>
      </template>
      <v-radio value="zarrinpal">
        <template v-slot:label>
          <div>زرین پال</div>
        </template>
      </v-radio>
    </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            انصراف
          </v-btn>
          <v-btn
          class="py-5 px-5"
          style="font-size:18px"
            color="green darken-1"
            :loading="loading"
            dark
            @click="pay()"
          >
            پرداخت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-row>
        <v-col class="plans"  cols="12" sm="12" >

   <v-card v-if="user.plan != 0" class="py-3 px-3 mb-3" outlined>
     <p>
       <span v-if="user.plan == 1">اشتراک شش ماهه</span>
       <span v-if="user.plan == 2">اشتراک سه ماهه</span>
       <span v-if="user.plan == 3">اشتراک یک ماهه</span>
     </p>
    انقصا {{ user.plan_expire | moment("jDD jMMMM  jYYYY") }}
<br>
 {{ $moment(user.plan_expire).toNow(true) }} مانده

</v-card>



<v-alert v-if="user.can_pay == 0"   color="red"   dense   text   type="error" >
شما در حال حاضر امکان خرید اشتراک ندارید لطفا از بخش پشتیبانی پیگیری کنید.
</v-alert>

<!-- @click="plan = 0;dialog = true" -->
   <v-card v-if="user.can_pay != 0 && user.plan_prices[0] != 0"
   :disabled="user.plan != 0 || user.can_pay == 0 || user.plan_prices[0] == 0" class=" lighten-1 plan" style="margin-bottom:10px;border:solid 1px #ccc"   flat>
          <v-card-title>
            <v-row>
              <v-col cols="6" class="px-1 py-1"> <p class=" mb-0" style="font-size:16px">  اشتراک شش  ماهه</p></v-col>
                   <v-col cols="6" class="px-1 py-1"><span style="float:left">{{(user.plan_prices[0]*1000).toLocaleString("fa-IR")}}  <span style="font-size:14px">تومان </span> </span></v-col>
            </v-row>
          </v-card-title>
    </v-card>

   <v-card v-if="user.can_pay != 0 && user.plan_prices[1] != 0" 
   :disabled="user.plan != 0 || user.can_pay == 0 || user.plan_prices[1] == 0" class=" accent-2 plan" style="margin-bottom:10px;border:solid 1px #ccc"   flat>
          <v-card-title>

                <v-row>
              <v-col cols="6" class="px-1 py-1"> <p class=" mb-0" style="font-size:16px">  اشتراک سه  ماهه</p></v-col>
                   <v-col cols="6" class="px-1 py-1"><span style="float:left">{{(user.plan_prices[1]*1000).toLocaleString("fa-IR")}}  <span style="font-size:14px">تومان </span> </span></v-col>
            </v-row>

          </v-card-title>
     
    </v-card>

    <v-card v-if="user.can_pay != 0 && user.plan_prices[2] != 0"
    :disabled="user.plan != 0 || user.can_pay == 0 || user.plan_prices[2] == 0" class=" plan" style="margin-bottom:10px;border:solid 1px #ccc"  flat>
          <v-card-title>

                 <v-row>
              <v-col cols="6" class="px-1 py-1"> <p class=" mb-0" style="font-size:16px">  اشتراک یک  ماهه</p></v-col>
                   <v-col cols="6" class="px-1 py-1"><span style="float:left">{{(user.plan_prices[2]*1000).toLocaleString("fa-IR")}}  <span style="font-size:14px">تومان </span> </span></v-col>
            </v-row>

          </v-card-title>
    </v-card>
<div v-if="user.can_pay != 0">
     <p>
      مبلغ مربوط به اشتراک مورد نظر خود را به شماره کارت زیر واریز کنید و از قسمت پشتیبانی کد پیگیری را ارسال کنید.
     </p>
<p style="direction: ltr;text-align: center;">
<span style="font-family: sans-serif;font-size:20px;font-weight:bold">5859 8311 5425 7116</span>
<input style="display:none" type="text" value="5859831154257116" id="myInput">
<br>
<span style="display:block;margin:10px 0">مصطفی ادیبی بانک تجارت</span>

<v-btn  @click="copy"
  elevation="1"
  small
>
  <v-icon  small class="mr-2">
        mdi-content-copy
      </v-icon>
کپی شماره کارت

</v-btn>

</p>
</div>

        </v-col>
    </v-row>
</v-container>
</template>
<script>
  export default {
    data: () => ({
      gateway: 'zarrinpal',
      snackbar : false,
dialog : false,
plan : '',
loading : false
    }),

   
    computed: {
          user (){  
         return this.$store.state.user_changes}
        },


 mounted(){



 },
    methods: {
      copy(){
  var copyText = document.getElementById("myInput");

  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  this.snackbar = true
      },
pay(){
this.loading = true
         var senddata = {data: {  data: ['insert', 'agent_transactions',
      {agent_id:this.$store.state.user_branding.id,plan_id:(this.plan+1),price:(this.user.plan_prices[this.plan]*1000)}] } , actions: ['insert'] };

 this.api_get(senddata).then((data) => {
 window.open("https://iranrepaircenter.ir/panel/api/gateways/zarrinpal/index.php?id="+data.data,"_self")

 })

    
}

    },
  }
</script>